<script>
import VueChartJs from 'vue-chartjs';

export default {
    name: 'EnrollmentChart',

    extends: VueChartJs.Doughnut,

    props: {
        totalEnrollment: {
            type: Number,
            required: true,
        },

        enrolled: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            chartOptions: {
                legend: {
                    display: false,
                },

                responsive: true,
                maintainAspectRatio: false,

                cutoutPercentage: 65,
                tooltips: {
                    enabled: false,
                },

                hover: { mode: null },

                plugins: {
                    datalabels: {
                        formatter: (value, ctx) => {
                            const datasets = ctx.chart.data.datasets;

                            if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
                                return `${Math.round((value / this.totalEnrollment) * 100)}%`;
                            }

                            return 0;
                        },
                        color: '#fff',
                        font: {
                            size: 16,
                        },
                    },
                },
            },
        };
    },

    computed: {
        planned() {
            const planned = this.totalEnrollment - this.enrolled;

            if (planned < 0) {
                return 0;
            }

            return planned;
        },

        chartData() {
            return {
                labels: ['Geïncludeerd', 'Gepland'],
                legend: {
                    display: false,
                },
                datasets: [
                    {
                        backgroundColor: ['#b90066', '#63666a'],
                        data: [this.enrolled, this.planned],
                    },
                ],
            };
        },
    },

    watch: {
        chartData() {
            this.updateChart();
        },
    },

    mounted() {
        this.updateChart();
    },

    methods: {
        updateChart() {
            this.renderChart(this.chartData, this.chartOptions);
        },
    },
};
</script>
